// Use This URL for testing
const URL = "labfix.bfiinfotech.co.in";

export const BASE_URL = `https://${URL}/api/`;
export const DOMAIN = `https://${URL}`;
export const MAX_COLS = 35;
export const ID_BASE = 1;
export const SRF_ID_BASE = 1;
export const MAX_SIZE_MB = 3;

export const SRF_ID_BASE_NABL = 393108;
export const SRF_ID_BASE_IAS = 1;
export const SRF_ID_BASE_NONABL = 1;

// TODO: need to move to DB
export const BANK_DETAILS = {
  "Bank Name": "Standard Bank, Queensburgh",
  "Bank A/c. No.": "252832116",
  "IFSC Code": "",
};

export const weightUncertaintySupportiveValues = {
  barometer: 2.4,
  tempIndicator: 0.58,
  rhIndicator: 1.74,
  weightBox: 7950,
};

export const G_Value = 9.80665;

export const GST_NUMBER = "27DSVPK5381Q1ZH";

export const DISABLED_MODULE =["Client Complaints","Client Feedback","ClientsUser","CoordinatesAddress","Settings","Datasheet Template","WCR Report","Discipline","Department Analytics","Supplier Invoice","Training Resources","Assigned Duc","Inward Register","SRF_ULR_Register","Document Upload","Request Form","History Reports","Audit","reservedSrf","emailOtpVerification","DatasheetReadingsAudit","UULIMS","locationTracking"]; 

export const DEVICE_TYPE = ["desktop", "tablet", "mobile"];

export const LATEST_HASH = "89e09b5893d3f6da022ade0dbd903a52d47c63c6";

export const TIME_ZONE_OFFSET =  "- INTERVAL 3 HOUR - INTERVAL 30 MINUTE ";
// - INTERVAL 3 HOUR - INTERVAL 30 MINUTE

export const DEFAULT_MAX_PRECISION = 10;

export const UnicodeCompany = "labfix";
